import type { RegionOption } from '../../../../shared/regionAccessOptions';
import RegionAccessPicker from '../../../../shared/RegionAccessPicker';
import { DIRECTOR_REGION_HINT, includesDirectorRole } from '../director-regions';
import type { UserRoleId } from '../roleTaxonomy';

import InviteFormField from './InviteFormField';

interface InviteRegionFieldProps {
  roleIds: UserRoleId[];
  options: RegionOption[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
}

/** The invite's region picker: several regions, or one for a Regional Director. */
export default function InviteRegionField({
  roleIds,
  options,
  selectedIds,
  onChange,
}: InviteRegionFieldProps) {
  const isDirector = includesDirectorRole(roleIds);
  return (
    <InviteFormField
      label={isDirector ? 'Region' : 'Regions'}
      required
      accent={isDirector ? 'one region' : 'region-scoped role'}
      hint={isDirector ? DIRECTOR_REGION_HINT : undefined}
    >
      <RegionAccessPicker
        options={options}
        selectedIds={selectedIds}
        onChange={onChange}
        single={isDirector}
      />
    </InviteFormField>
  );
}
